var DealerInspireDealTimer = (function () {
  //////////////////////////////////////////
  // Set cookies and other functions
  //////////////////////////////////////////
  var cookieId = 'di_deal_timer',
    cookieValue =  JSON.parse(readCookie(cookieId)) || {},
    initTime = new Date(),
    targetTime = new Date(),
    timerCookieExists = !jQuery.isEmptyObject(cookieValue) ? true : false,
    timerContainer = jQuery('.countdown-timer'),
    timerMessage = jQuery('.countdown-timer__message', timerContainer),
    timerClock = jQuery('.countdown-timer__timer', timerContainer),
    timerTab = jQuery('.countdown-timer-tab'),
    timerClose = jQuery('.countdown-close', timerContainer);

  function readCookie (c_name) {
    var c_value = document.cookie;
    var c_start = c_value.indexOf(" " + c_name + "=");

    if (c_start == -1) {
      c_start = c_value.indexOf(c_name + "=");
    }

    if (c_start == -1) {
      c_value = null;
    } else {
      c_start = c_value.indexOf("=", c_start) + 1;
      var c_end = c_value.indexOf(";", c_start);
      if (c_end == -1) {
        c_end = c_value.length;
      }
      c_value = unescape(c_value.substring(c_start, c_end));
    }

    return c_value ? c_value : null;
  }

  function createCookie (name, value, days) {
    var expires = '';

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }

    if (typeof value == 'object') {
      value = JSON.stringify(value);
    }

    document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
  }

  function eraseCookie (name) {
    createCookie(name, "", -1);
  }

  function initTimer () {
    if (timerContainer.length > 0) {
      // Check to make sure cookie is set
      if (cookieValue.hasOwnProperty('targetTime')) {
        startTimer();
      } else {
        jQuery.when( setCookieTime() ).done(function () {
          startTimer();
        });
      }
    }
  }

  function setCookieTime() {
    var deferred = jQuery.Deferred();

    targetTime.setMinutes(initTime.getMinutes() + 30);
    cookieValue.initTime = initTime;
    cookieValue.targetTime = targetTime;

    createCookie(cookieId, cookieValue, 7);

    // return promise so we can defer until cookie creation has occurred
    return deferred.resolve();
  }

  function showFinishedMessage () {
    jQuery(timerMessage).find('.message-text').fadeOut(function () {
      jQuery(timerMessage).find('.message-finished-text').fadeIn();
    });
  }

  function slideDrawer () {
    requestAnimationFrame(function () {
      var y_scroll_pos = window.pageYOffset,
        scroll_pos_test = 200;

      if (y_scroll_pos > scroll_pos_test) {
        jQuery(window).off('scroll', slideDrawer);
        hideTimer();
      }
    });
  }

  function initTimerEvents () {
    // clicking on the countdown close button hides the timer
    jQuery(timerClose).on('click', function (e) {
      localStorage.setItem('timerMessageDismissed', 'true');
      e.stopPropagation();
      hideTimer();
      return false;
    });

    // clicking on the tab brings back the timer
    jQuery(timerTab).on('click', function (e) {
      e.stopPropagation();
      showTimer();
      return false;
    });

    jQuery(window).on('scroll', slideDrawer);
  }

  function hideTimer() {
    jQuery(timerContainer).addClass('inactive');
    jQuery(timerTab).removeClass('inactive');
  }

  function showTimer () {
    jQuery(timerContainer).removeClass('inactive');
    jQuery(timerTab).addClass('inactive');
  }

  if (localStorage.getItem('timerMessageDismissed') === 'true') {
    hideTimer();
  } else {
    showTimer();
  }

  function startTimer () {
    jQuery(document).ready(function () {
      // Set the starting time to end of April
      var targetTimeData = jQuery(timerContainer).data('target-time'),
        targetTimeFormatted = new Date(targetTimeData);
      if (!isNaN(targetTimeFormatted)) {
        // init the clock and then fade in the timerContainer
        jQuery(timerClock)
          .countdown(targetTimeFormatted, function (event) {
            jQuery(this).find('.timer-days').text(event.strftime('%D'));
            jQuery(this).find('.timer-hours').text(event.strftime('%H'));
            jQuery(this).find('.timer-minutes').text(event.strftime('%M'));
            jQuery(this).find('.timer-seconds').text(event.strftime('%S'));

            if (event.type === 'finish') {
              jQuery(this).addClass('finished');
              showFinishedMessage();
            }
          })
          .on('finish.countdown', function (event) {
            jQuery(this).addClass('finished');
            showFinishedMessage();
          })
          .parents()
          .css({opacity: 1});

        // add minutes to the tab container
        jQuery(timerTab).countdown(targetTimeFormatted, function (event) {
          if (event.type === 'finish') {
            jQuery(this).text('Claim your deal!');
          } else {
            jQuery(this).text(event.strftime('%-D') + ' days' + (' ') + event.strftime('%-H') + ' hours left!');
          }
        });

        initTimerEvents();
      }
      else{
        console.error(
          "ERROR: not able to initialize DealTimer",
          "Date: " + targetTimeFormatted
        );
      }
    });
  }

  // throw an error if jquery is undefined
  if (typeof jQuery === 'undefined' || typeof jQuery.fn.countdown === 'undefined') {
    console.log("DealTimer cannot find jQuery.");
    return false;
  } else {
    // kick off the script
    initTimer();
  }

  /////////////////////////////////////////////////
  // Some useful exposed functions
  /////////////////////////////////////////////////
  return {
    getCookieValue: function () {
      return cookieValue;
    },
    destroyCookie: function () {
      eraseCookie(cookieId);
      cookieValue = {};
    }
  };
}());